import script from "./ProductListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductListItem.vue?vue&type=script&setup=true&lang=js"

import "./ProductListItem.vue?vue&type=style&index=0&id=049fbe26&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-049fbe26"]])

export default __exports__